document.addEventListener('DOMContentLoaded', function() {

  function faqAccordion() {
    var $accordion = $('.faqAccordion');

    if (!$accordion.length) return; // exit if no FAQ on this page

    // Initial state — collapse all answers
    $accordion.find('> dd')
      .attr('aria-hidden', 'true')
      .prop('inert', true)
      .hide();

    // Set initial ARIA on triggers
    $accordion.find('> dt button, > dt a')
      .attr('aria-expanded', 'false');

    // Toggle on click
    $accordion.find('> dt').on('click', function() {
      var $dt    = $(this);
      var $dd    = $dt.next('dd');
      var isOpen = $dd.attr('aria-hidden') === 'false';

      if (isOpen) {
        // Close
        $dd.attr('aria-hidden', 'true').prop('inert', true).slideUp();
        $dt.find('button, a').attr('aria-expanded', 'false');
        $dt.removeClass('active');
        $dd.removeClass('active');

      } else {
        // Close all others
        $accordion.find('> dd')
          .attr('aria-hidden', 'true').prop('inert', true).slideUp();
        $accordion.find('> dt')
          .removeClass('active')
          .find('button, a').attr('aria-expanded', 'false');
        $accordion.find('> dd').removeClass('active');

        // Open this one
        $dd.attr('aria-hidden', 'false').prop('inert', false).slideDown();
        $dt.find('button, a').attr('aria-expanded', 'true');
        $dt.addClass('active');
        $dd.addClass('active');
      }
    });
  }

  faqAccordion();

});
